import { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import AddBoxIcon from '@mui/icons-material/AddBox';
import CreateProject from '../../components/CreateProject/CreateProject';
import ProjectList from '../../components/ProjectList/ProjectList';
import '../notifications/index.css';
import Hamburger from '../../components/HamburgerMenu/HamburgerMenu';
export function ProjectRoute() {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  return (
    <>
      {anchorEl && (
        <div className="popper">
          <CreateProject anchorEl={anchorEl} onClose={handleClick} />
        </div>
      )}
      <div className="topActions">
        <Hamburger></Hamburger>
        <h1>Project Monitor </h1>
        <div className="topProjectButtons">
          <button onClick={handleClick}>
            <AddBoxIcon size="small" />
            Add Project
          </button>
        </div>
      </div>
      <ProjectList />
    </>
  );
}
